import React from 'react';

interface CustomMapProps {
}

const CustomMap: React.FC<CustomMapProps> = ({ }) => {
    return (
        <>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1436.5614764668746!2d17.576582!3d43.936129!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475f0d007f4e753d%3A0x79fcd68ce7b7ee56!2sEnduroRemi.com%20%7C%20by%20Petar!5e0!3m2!1sen!2sba!4v1767817715102!5m2!1sen!2sba"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: 8 }}
                loading="lazy" ></iframe>
        </>
    )
}

export default CustomMap;